import ControlCheckboxes from "./ControlCheckboxes"
import { Props as IsAddHomeVideoCheckboxProps } from "./IsAddHomeVideo"
import { Props as IsCompactCheckboxProps } from "./IsCompact"
import { Props as IsMatchTitleCheckboxProps } from "./IsMatchTitleCheckbox"
import { Props as IsSingleSourceCheckboxProps } from "./IsSingleSource"
import { Props as IsUHDCheckboxProps } from "./IsUHDCheckbox"

export interface Props {
  isAddHomeVideoProps?: IsAddHomeVideoCheckboxProps
  isAdmin?: boolean
  isEditor?: boolean
  isCompactCheckboxProps?: IsCompactCheckboxProps
  isMatchTitleCheckboxProps?: IsMatchTitleCheckboxProps
  isSingleSourceCheckboxProps?: IsSingleSourceCheckboxProps
  isUHDCheckboxProps?: IsUHDCheckboxProps
}

export interface ComponentProps extends Props {}

export default ControlCheckboxes
